import type { BigFraction } from "@aprao/common/src/math/BigFraction.js";
import { divide } from "@aprao/common/src/math/divide.js";
import { makeAutoObservable } from "mobx";

import type { ShapeSalesGroupBase } from "../../shapes/ShapeRevenueGroup.js";

export class SalesGroupBaseFacade {
  constructor(
    readonly $model: ShapeSalesGroupBase,
    readonly _providers: {
      valueGross(): BigFraction | null;
      areaTotal(): BigFraction | null;
    },
  ) {
    makeAutoObservable(this);
  }

  get linkedBuildPhaseRefId() {
    return this.$model.linkedBuildPhaseRefId;
  }

  get averageValuePerArea() {
    return divide(this._providers.valueGross(), this._providers.areaTotal());
  }
}
